import script from "./UserRegistrationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./UserRegistrationForm.vue?vue&type=script&setup=true&lang=js"

import "./UserRegistrationForm.vue?vue&type=style&index=0&id=abf127ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abf127ea"]])

export default __exports__